<!-- 挣钱弹框 -->
<template>
  <div class="container">
    <el-dialog center :visible.sync="dialogVisible" width="50%">
      <div class="title">速度挣钱哦~~</div>
      <div style="padding: 0 0.24rem">
        <p class="p1" style="margin-bottom: 0.24rem; font-weight: bold">
          提示：您完成下方相应任务即可获得奖励金！
          奖励金将直接进入您的机构余额，<span
            >奖励金可用于支付您的VIP会员费</span
          >
          、购买销售活动中需要的 平台红包等，但奖励金不可直接提现。
        </p>
        <div class="main">
          <div>
            <div v-for="item in 5" :key="item" class="mainLine">
              <p class="p2">每成功生成 <span>20</span> 库存</p>
              <p class="p3">即可获得</p>
              <p >
                <span class="span1">100</span> <span class="span2">积分</span>
              </p>
              <p class="p4">+</p>
              <p class="p5">
                <span class="span1">200</span> <span>奖励金</span>
              </p>
              <el-button class="btns" size="small" type="primary">马上去添加库存 </el-button>
            </div>
            <p class="p6">说明：XXXXXXXXX</p>
          </div>
        </div>
      </div>

      <el-button class="btns" size="small" slot="footer" type="primary" @click="dialogVisible = false"
        >关闭</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      current: "",
    };
  },
  computed: {
  },
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header {
  padding: 0 !important;
}
/deep/ .el-dialog__body {
  padding: 0 !important;
}
/deep/ .el-dialog__footer {
  padding-bottom: 0.24rem !important;
}
.container {
  .btns {
    color: #3C8076;
    background-color: #E5F5F3;
    border-color: #E5F5F3;
  }
  .active {
    background-color: var(--color) !important;
    color: #fff !important;
  }
  .title {
    height: 0.5rem;
    background-color: #E5F5F3;
    color: #000;
    padding-left: 0.24rem;
    text-align: left;
    line-height: 0.5rem;
    margin-bottom: 0.24rem;
  }
  .p1 {
    color: #000;
    font-size: 0.14rem;
    font-family: SourceHanSansSC-bold;
    margin-bottom: 3rem;
    span {
      color: #d5562e;
    }
  }
  .btnBox {
    display: flex;
    align-items: center;
  }
  .main {
    background-color: rgba(255, 255, 255, 1);
    color: rgba(16, 16, 16, 1);
    font-family: Roboto;
    border: 1px solid rgba(236, 101, 26, 1);
    padding: 0.4rem 0.6rem;
    display: flex;
     justify-content: center;
      align-items: center;
    .mainLine {
      display: flex;
      align-items: center;
      margin-bottom: 0.3rem;
     
      .p2 {
        display: flex;
        align-items: center;
        color: rgba(16, 16, 16, 1);
        font-size: 0.14rem;
        font-family: SourceHanSansSC-bold;
        font-weight: bold;
        margin-right: 0.34rem;
        span {
          color: rgba(230, 74, 25, 1);
          font-size: 0.2rem;
          font-family: SourceHanSansSC-black;
        }
      }
      .p3 {
        color: rgba(230, 74, 25, 1);
        font-size: 0.16rem;
        font-family: SourceHanSansSC-bold;
        font-weight: bold;
        margin-right: 0.34rem;
      }
      .span1 {
        font-family: SourceHanSansSC-bold;
        font-weight: bold;
        font-style: italic;
        font-size: 0.2rem;
        color: #e64a19;
        text-decoration: underline;
      }
      .span2 {
      }
      .p4 {
        font-weight: bold;
        font-size: 0.4rem;
        margin: 0 0.12rem;
      }
      .p5 {
        margin-right: 0.5rem;
      }
      .p6 {
        color: rgba(57, 72, 87, 0.86);
        font-size: 0.12rem;
        font-family: SourceHanSansSC-regular;
      }
    }
  }
}
</style>
